import React from "react";

interface ModalPortalContextValue {
  element: HTMLElement | null;
  register: (el: HTMLElement | null) => void;
}

const ModalPortalContext = React.createContext<ModalPortalContextValue>({
  element: null,
  register: () => {},
});

/** Returns the modal portal container when inside a dialog, or undefined to use default portaling. */
export function useModalPortal(): HTMLElement | undefined {
  const { element } = React.useContext(ModalPortalContext);
  return element ?? undefined;
}

export default ModalPortalContext;
